import { useEffect, useState } from "react";
import { SetOrderRule } from "../../components/OrderRule"
import { getOrderRule } from "../../service/api/OrderRule/apiOrderRule";

const OrderRule = () => {
    const [orderRuleData, setOrderRuleData] = useState([]);
    useEffect(() => {
        getOrderRule()
            .then(response => {
                if (response?.status === 200) {
                    console.log(response.data.result[0])
                    setOrderRuleData(response.data.result[0]);
                }
            });
    }, []);
    return (
        <>
            <div>
                <SetOrderRule
                data={orderRuleData} />
            </div>
        </>
    )
}
export { OrderRule }